import { render } from "./LedDot.vue?vue&type=template&id=6560dd5a&scoped=true"
import script from "./LedDot.vue?vue&type=script&lang=js"
export * from "./LedDot.vue?vue&type=script&lang=js"

import "./LedDot.vue?vue&type=style&index=0&id=6560dd5a&scoped=true&lang=css"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6560dd5a"]])

export default __exports__